import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { User } from '../../models/user';
import { AuthenticationService } from '../../services/authentication.service';

@Component({
  selector: 'mdk-user-menu',
  templateUrl: './user-menu.component.html'
})
export class UserMenuComponent implements OnInit {
  constructor(private authService: AuthenticationService) {}

  userName$!: Observable<string>;
  initials$!: Observable<string>;

  ngOnInit() {
    this.initStreams();
  }

  private initStreams(): void {
    this.userName$ = this.authService.user$.pipe(
      map((user: User) => user.firstName + ' ' + user.lastName)
    );
    this.initials$ = this.authService.user$.pipe(
      map((user: User) => user.firstName?.charAt(0).toUpperCase() + '' +  user.lastName?.charAt(0).toUpperCase())
    );
  }

  onLogOut(): void {
    this.authService.logout();
  }
}
